import { Button, Card, createTheme, MantineProvider, Stack, Text, Title } from "@mantine/core";
import { createFileRoute, useRouterState } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { CheckInCancel } from "@/pages/App/Driver/DriverCheckIn/CheckInSteps/CheckInCancel";
import { CheckInCompleted } from "@/pages/App/Driver/DriverCheckIn/CheckInSteps/CheckInCompleted";
import { CheckInStepConfirm } from "@/pages/App/Driver/DriverCheckIn/CheckInSteps/CheckInStepConfirm";
import { CheckInStepWarning } from "@/pages/App/Driver/DriverCheckIn/CheckInSteps/CheckInStepWarning";
import { cn } from "@/utils/cn";

const TOTAL_STEPS = 4;
const theme = createTheme({
  components: {
    Button: Button.extend({
      defaultProps: {
        color: "blue.6"
      }
    }),
    Stack: Stack.extend({
      defaultProps: {
        gap: 0
      }
    }),
    Text: Text.extend({
      defaultProps: {
        lh: "normal",
        className: cn("text-gray-600!")
      }
    }),
    Title: Title.extend({
      defaultProps: {
        mt: 0,
        ta: "center",
        className: cn("text-gray-600")
      }
    })
  }
});

export const Route = createFileRoute("/app/checkin/")({
  component: DriverCheckIn,
  context: ({ location }) => {
    const stepId = location.state?.stepId || 1;
    const checkin = location.state?.checkin?.updatedAt || "";

    return {
      stepId,
      checkin
    };
  }
});

export function DriverCheckIn() {
  const { location } = useRouterState();
  const { stepId, checkin } = Route.useRouteContext({
    select(search) {
      return {
        stepId: search.stepId,
        checkin: search.checkin
      };
    }
  });

  const [currentStep, setCurrentStep] = useState(stepId);

  const handleNextStepForm = () => {
    if (currentStep < TOTAL_STEPS) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const renderStep = (index: number) => {
    switch (index) {
      case 1:
        return <CheckInStepWarning onNextStep={handleNextStepForm} />;
      case 2:
        return <CheckInStepConfirm onNextStep={handleNextStepForm} />;
      case 3:
        return <CheckInCompleted />;
      case 4:
        return <CheckInCancel cancelDate={checkin} />;
    }
  };

  useEffect(() => {
    if (location.state) {
      setCurrentStep(stepId);
    }
  }, [location.state, stepId]);

  return (
    <Card radius="md" shadow="md" maw={450} className="w-full!" withBorder>
      <Stack className="relative! min-h-96" align="center" justify="space-between">
        <MantineProvider theme={theme}>{renderStep(currentStep)}</MantineProvider>
      </Stack>
    </Card>
  );
}
